const JobSearchEnum = Object.freeze({
  Čeština: 'Hledání práce',
  Deutsch: 'Jobsuche',
  Français: "Offres d'emploi",
  Slovenčina: 'Vyhľadávanie práce',
  Español: 'Búsqueda de empleo',
  English: 'Job Search',
})

export default JobSearchEnum
